import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import IconWithText from '@/components/ui/IconWithText/IconWithText';
import { BankAccountDtoIn } from '@/models/in/BankAccountDtoIn';
import bankIcon from '@/assets/icons/bank.svg';

interface BankAccountLineProps {
  account: BankAccountDtoIn;
  /** Shown after the owner's name - the «נמחק» tag of the account that bounced. */
  tag?: ReactNode;
}

/**
 * One bank account exactly as «פרטי תשלום» lists a supported's accounts (ExistingPaymentInfos): the
 * owner's name under a teal bar, then bank, branch and account on one line. The coordinator already
 * knows to read an account this way.
 */
const BankAccountLine = ({ account, tag }: BankAccountLineProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 min-w-0">
      <div className="flex gap-2 items-center flex-wrap">
        <div className="h-[15px] border-l-2 border-(--border-tertiary-strong)"></div>
        <span className="body-lr-semibold text-(--font-body-1)">{account.accountOwnerName}</span>
        {tag}
      </div>
      <IconWithText
        icon={bankIcon}
        text={`${t('bank')} ${account.bankNumber}${account.bankName ? ` (${account.bankName})` : ''}, ${t('branch')} ${account.branchNumber}, ${t('account')} ${account.accountNumber}`}
      />
    </div>
  );
};

export default BankAccountLine;
